import React from 'react'
import {connect} from 'dva'
import {Alert, Button, Form, Icon, Input, Row} from 'antd'
import styles from './index.module.less'

const FormItem = Form.Item

const Login = ({
                 login,
                 loading,
                 dispatch,
                 form: {
                   getFieldDecorator,
                   validateFieldsAndScroll,
                   getFieldValue,
                 },
               }) => {

  const {errorMessage, countDown} = login
  const verifyCodeSending = !!loading.effects[`login/sendVerifyCode`]

  let buttonText = '发送验证码'
  if (verifyCodeSending) {
    buttonText = `正在发送...`
  }
  if (countDown > 0) {
    buttonText = `${countDown}秒后获取`
  }

  const sendVerifyCode = () => {
    const phoneNo = getFieldValue('phoneNo')
    if (/^1[3456789][0-9]{9}$/.test(phoneNo) && countDown === 0 && !verifyCodeSending) {
      dispatch({
        type: `login/sendVerifyCode`,
        payload: getFieldValue('phoneNo')
      })
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    validateFieldsAndScroll((errors, {phoneNo, verifyCode}) => {
      if (errors) {
        return
      }
      dispatch({
        type: 'login/login',
        payload: {
          phoneNo: phoneNo.trim(),
          verifyCode,
        },
      })
    })
  }

  function renderMessage(content) {
    return <Alert style={{marginBottom: 18}} message={content} type="error" showIcon/>
  }

  return (
    <div className={styles.login}>
      <div className={styles.main}>
        <h1>
          信息验证
          {/*<div>如还没注册，请点击此处 注册</div>*/}
        </h1>
        <div className={styles.form}>
          <Form onSubmit={handleSubmit}>
            {errorMessage && !loading.effects.login && renderMessage(errorMessage)}
            <FormItem>
              {getFieldDecorator('phoneNo', {
                rules: [
                  {
                    required: true,
                    message: '请输入手机号码',
                  },
                ],
              })(<Input
                prefix={<Icon type="mobile" style={{color: 'rgba(0,0,0,.25)'}}/>}
                size={"large"} autoFocus placeholder="手机号码"/>)}
            </FormItem>
            <FormItem>
              {getFieldDecorator('verifyCode', {
                initialValue: '',
                rules: [
                  {
                    required: true,
                    message: '请输入验证码',
                  },
                ],
              })(<Input
                type="password"
                prefix={<Icon type="key" style={{color: 'rgba(0,0,0,.25)'}}/>}
                suffix={<a onClick={sendVerifyCode}>{buttonText}</a>}
                size={"large"} placeholder="验证码"/>)}
            </FormItem>
            <div>
              <Button type="primary" size={"large"} htmlType={"submit"} loading={loading.effects.login}>
                登录
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default connect(({login, loading}) => ({
  loading,
  login,
}))(Form.create()(Login))
